import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar/Navbar";
import HeroSection from "../components/HeroSection/HeroSection";
import ServicesSection from "../components/ServicesSection/ServicesSection";
import AboutUs from "../components/AboutUs/AboutUs";
import OurClients from "../components/OurClients/OurClients";
import Footer from "../components/Footer/Footer";
import ContactUs from "../components/ContactUs/ContactUs";
import RedonaAI from "../components/RedonaAi/RedonaAI";
import Products from "../components/Products/Products";
import { Router, Route } from "react-router-dom";
import Erp from "./ERP/Erp";
import ClientStories from "../components/ClientStories/ClientStories";

const HomePage = () => {
  const [currentSection, setCurrentSection] = useState("home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "services", "about", "clients", "contact"];
      let activeSection = "home";
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (
            rect.top <= window.innerHeight / 2 &&
            rect.bottom >= window.innerHeight / 2
          ) {
            activeSection = sections[i];
            break;
          }
        }
      }
      setCurrentSection(activeSection);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Navbar
        setCurrentSection={setCurrentSection}
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
      />
      <HeroSection />
      <ServicesSection />
      <Products />
      <AboutUs />
      <OurClients />
      <ClientStories />
      <RedonaAI />
      <ContactUs />
    </>
  );
};

export default HomePage;
